import { createStore } from 'vuex'

export default createStore({
  state: {
    apiUrl: 'https://testapi2.nn8qozmu.top:5000',
    nickname: null
  },
  getters: {
  },
  mutations: {
    saveNickname (state, nickname) {
      state.nickname = nickname
    }
  },
  actions: {
  },
  modules: {
  }
})
